import * as React from "react";
import Helmet from "@/components/Helmet";
import { useTheme } from "@/hooks/useTheme";
import NewErrorPage from "@/components/pages/new/error";
import SetupContract from "@/components/SetupContract";

const ErrorPage = () => {
  const { isNewTheme } = useTheme();
  return (
    <SetupContract>
      <Helmet title="AI査定ツール | 500 Server Error." meta={[{ name: "robots", content: "noindex,nofollow" }]} />
      <NewErrorPage />
    </SetupContract>
  );
};

export default ErrorPage;
